module.exports = __webpack_public_path__ + "media/images/icon_crown02-468b771a167e5dd037f36dc19dcb6442.png";